<script>
    import { format } from 'svelte-i18n';
    import { removeTags } from '../../js/utils.js';
    import { handleFindingsUpsert } from './findings.state.svelte.js';

    let { selected_rows, closeEditModal } = $props();

    let is_loading = $state(false);

    let formData = {};
    let formIsSubmitted = false;
    // API string errors
    let APIerror = null;
    // API 422 errors

    async function handleSubmit(event) {
        event.preventDefault();
        formIsSubmitted = true;
        // reset API errors

        if(selected_rows.length > 100){
            loading = false;
            return APIerror = $format("notifications.max_100");
        }

        let data = [];
        is_loading = true;
        for(let [idx, finding] of Object.entries(selected_rows)){
            if(!formData.description) formData.description = "";
            finding.description = formData.description;
            data.push({id: finding.id, description: finding.description});
        }
        closeEditModal();
        let response = await handleFindingsUpsert(data);
        let errors   = response.errors ? response.errors : null;

        formIsSubmitted = false;
        APIerror = null;
        is_loading = false;
        formData.description = "";
    }
    function handleCloseModal(){
        formIsSubmitted = false;
    }

    const handleKeydown = event => {

        if(event.key == "Escape"){
            handleCloseModal();
        }
        else {
            return;
        }
    }

</script>


<svelte:window on:keydown={handleKeydown}/>

<form role="form" novalidate onsubmit={handleSubmit}>
    <div class="card">
        <div class="card-body">
            <div class="mb-3">
                <label for="description">{$format("form.fields.description")}</label>
                <input
                    type="text"
                    class="form-control t-input-source-code-description"
                    id="findingAddDescription"
                    name="description"
                    placeholder={$format("form.fields.description")}
                    bind:value={formData.description}
                />
            </div>
            <div class="alert alert-warning">
                <span for="name">{$format("form.helpers.massive_edit_helper")}</span>
            </div>
        </div>
        {#if !is_loading}
            <div class="card-footer">
                <button id="findingAddSubmit" type="submit" class="btn btn-primary t-submit-source-code-btn">{$format("buttons.save")}</button>
                <button class="btn btn-default" onclick={handleCloseModal} data-bs-dismiss="modal">{$format("buttons.cancel")}</button>
            </div>
        {:else}
            <div class="overlay">
                <i class="fas fa-2x fa-sync-alt fa-spin" />
            </div>
        {/if}
    </div>
</form>
